import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PropertiesDictionaryComponent} from './properties-dictionary.component';
import {PropertiesDictionarySummaryComponent} from './properties-dictionary-summary/properties-dictionary-summary.component';
import {PropertiesDictionaryDialogComponent} from './properties-dictionary-dialog/properties-dictionary-dialog.component';
import {PipsModule} from '../../pipes/pips.module';
import {FlexModule} from '@angular/flex-layout';
import {MatTableModule} from '@angular/material/table';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {ColumnsFilterModule} from '../../components/columns-filter/columns-filter.module';
import {MapModule} from '../../network/map/map.module';
import {LayoutModule} from '../../components/layout/layout.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {MaterialModule} from '../../material.module';
import {ClientFilterModule} from '../../components/client-filter/client-filter.module';

@NgModule({
  declarations: [
    PropertiesDictionaryComponent,
    PropertiesDictionaryDialogComponent,
    PropertiesDictionarySummaryComponent
  ],
    imports: [
        CommonModule,
        PipsModule,
        FlexModule,
        MatTableModule,
        DialogModule,
        FormsModule,
        ColumnsFilterModule,
        MapModule,
        LayoutModule,
        MaterialModule,
        ActionBarModule,
        ArmTableModule,
        ClientFilterModule
    ]
})
export class PropertiesDictionaryModule { }
